export default "__VITE_ASSET__B$KgiWUH__"